import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';

import { Grid } from '../../../lib/grid';
import { DataSource } from '../../../lib/data-source/data-source';
import { Column } from '../../../lib/data-set/column';

@Component({
    selector: '[ng2-st-thead-titles-row]',
    template: `
    <th
      ng2-st-checkbox-select-all
      *ngIf="isMultiSelectVisible"
      [grid]="grid"
      [source]="source"
      [isAllSelected]="isAllSelected"
      (click)="selectAllRowsFunction($event)"
    ></th>
    <th ng2-st-actions-title *ngIf="showActionColumnLeft" [grid]="grid"></th>
    <th
      *ngFor="let column of grid.getColumns()"
      class="ng2-smart-th {{ column.id }}"
      [ngClass]="column.class"
      [style.width.%]="column.width"
      id="{{ column.id }}"
    >
      <ng2-st-column-title
        [source]="source"
        [column]="column"
        (sort)="sort.emit($event)"
      ></ng2-st-column-title>
    </th>
    <th ng2-st-actions-title *ngIf="showActionColumnRight" [grid]="grid"></th>
  `,
    standalone: false
})
export class TheadTitlesRowComponent implements OnChanges {
  @Input() public grid: Grid;
  @Input() public isAllSelected: boolean;
  @Input() public source: DataSource;

  @Output() public sort = new EventEmitter<any>();
  @Output() public selectAllRows = new EventEmitter<any>();

  public isMultiSelectVisible: boolean;
  public showActionColumnLeft: boolean;
  public showActionColumnRight: boolean;

  public selectAllRowsFunction(event: any) {
    const rows = this.grid.getRows();
    let isUpdateMode = false;
    for (const row of rows) {
      if (row.disableCheckBox) {
        isUpdateMode = true;
      }
    }
    if (!isUpdateMode) {
      this.selectAllRows.emit(event);
    }
  }

  public ngOnChanges() {
    this.isMultiSelectVisible = this.grid.isMultiSelectVisible();
    this.showActionColumnLeft = this.grid.showActionColumn('left');
    this.showActionColumnRight = this.grid.showActionColumn('right');
  }
}
